import { NBSP } from 'shared/constants/symbols';
import first from './assets/first.png';
import second from './assets/second.png';
import third from './assets/third.png';

export const UTP = [
  {
    title:
      'Учитываем вероятность просмотра или отклика по объекту потенциальным клиентом. Чем она выше, тем выше объявление',
    image: first,
  },
  {
    title: `Размер ставки влияет на позицию объявления в результатах поиска, но${NBSP}не гарантирует ее`,
    image: second,
  },
  {
    title: `Чем больше ставка, тем${NBSP}чаще показываем объявление на первых позициях, и тем больше просмотров вы получите`,
    image: third,
  },
];
